import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import EventCard from './EventCard'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import { convertParkingTime } from '../../utils/helper'
import { Col, Row } from 'react-bootstrap'
import CommonBtn from './CommonBtn'
import { globalKeyStore } from '../../redux/actions/globalState'
import { useLocation, useNavigate } from 'react-router'
// import URL from '../../constants/urls'
import PrevArrow from './Arrows/PrevArrow'
import NextArrow from './Arrows/NextArrow'
import { useParams } from 'react-router-dom'
import { getPriceBreakdown } from '../../utils/helper'

function MultipleEventCrousel({ passData, isMainScreen, dispatch, selectEventType, sessionDetails, displayQr, hidePaymentDetails, paymentResponse, eventViewStyle }) {
    const slider = React.useRef(null)
    const [passSold, setPassSold] = useState(null)
    const passDetails = JSON.parse(localStorage.getItem('passDetails'))
    const {facility} = useParams()
    useEffect(() => {
        // if(Object.values(passData)?.length < 1){
        if (!passData) {
            const passdata = JSON.parse(localStorage.getItem('passData'))
            dispatch(globalKeyStore({ selectedPassId: Number(passdata?.id), passData: passdata }))
            if(passdata.id) {
                let passArr = passDetails.filter((item) => {
                    return passdata.id == item.pass_id
                })
                setPassSold(passArr.length > 0 ? passArr[0].is_pass_sold : null)
                // console.log(passdata.id, passArr[0].is_pass_sold, 'passArr.is_pass_sold')
            } else {
                setPassSold(null)
            }
        } else {
            if(passData.id) {
                let passArr = passDetails.filter((item) => {
                    return passData.id == item.pass_id
                })
                setPassSold(passArr.length > 0 ? passArr[0].is_pass_sold : null)
                // console.log(passData.id, passArr[0].is_pass_sold, 'passArr.is_pass_sold')
            } else [
                setPassSold(null)
            ]
        }
        // }
    }, [EMPTY_ARRAY])

    const user = useLocation()?.pathname

    const navigate = useNavigate()

    const handleBookingButtton = (passData = null) => {
        dispatch(globalKeyStore({ selectedPassId: passData?.id }))
        localStorage?.setItem('booking_event', passData?.id)
        if (user) {
            // navigate(`${user}/${URL?.BOOKING_PAGE}/${passData?.id}`) // Old functionality
            if(facility){
                navigate(`/${user?.replace(/\//g, '')}/${facility}${passData?.id ? '/' + passData?.id : ''}/bookingdetail`)
            }else{
                navigate(`/${user?.replace(/\//g, '')}${passData?.facility_id ? '/' + passData?.facility_id : '/'}${passData?.id ? '/' + passData?.id : ''}/bookingdetail`)
            }
        } else {
            navigate('*')
        }
    }

    // important setting for the crousel 
    const settings = {
        dots: true, infinite: true, speed: 2000, slidesToShow: 1, slidesToScroll: 1, autoplay: true, autoplaySpeed: 4000, cssEase: 'ease-out',
        responsive: [{ breakpoint: 600, settings: { arrows: false } }],
        nextArrow: <NextArrow onClick={() => slider?.current?.slickNext()} />,
        prevArrow: <PrevArrow onClick={() => slider?.current?.slickPrev()} />
    }
    // console.log(passData, 'passData')

    return (
        isMainScreen ? <div>
            <Row className='py-3 g-0 mt-2'>
                <Col><h3 className='text-primary fw-bold'>{passData?.description}</h3></Col>
                {(passData?.all_event?.length > 0) && <Col className='col-auto d-flex align-items-center'>{(passData?.all_event?.length > 0) ? <span className='fw-bold text-primary pe-4 h4 text-center mt-2'>${Number(passData?.price)?.toFixed(2)}</span> : ''}<CommonBtn type='button' disabled={(passSold && Number(passSold) === 1) ? true : (passData?.all_event?.length > 0) ? false : true} className={(passSold && Number(passSold) === 1) ? 'btn btn-lg btn-outline-danger fw-bold' : 'btn btn-primary'} value={(passSold && Number(passSold) === 1) ? 'Sold Out' : 'Book'} onClick={() => handleBookingButtton(passData)} /></Col>}
            </Row>
            <Row className={(eventViewStyle == 'list') ? 'row row-cols-1 g-4 mt-0 col-cols-sm-2' : 'row row-cols-2 g-4 mt-0 col-cols-sm-2'}>
                {(passData?.all_event?.length > 0) ?
                    // <Slider {...settings} className='mb-3'>
                    passData?.all_event?.map((item, index) =>
                        <EventCard
                            key={item?.id}
                            qrCodeValue={paymentResponse?.mapco_qrcode?.[index]?.qrcode}
                            imageUrl={(item?.image_url) ? item?.image_url : 'NoImage'}
                            title={item?.title}
                            detials={item?.description}
                            startDate={item?.start_time}
                            time={convertParkingTime(item?.parking_start_time, item?.parking_end_time)}
                            // paybaleAmount={item?.paybaleAmount ? item?.paybaleAmount : ''}
                            id={item?.id}
                            parkingPrice={selectEventType == 'event' ? item?.event_rate : item?.price ? item?.price : 0}
                            tax_rate={item?.tax_rate ? item?.tax_rate?.toFixed(2) : 0}
                            amount={item?.amount ? item?.amount?.toFixed(2) : 0}
                            displayQr={displayQr}
                            hidePaymentDetails={hidePaymentDetails}
                            paymentResponse={paymentResponse}
                            isCrousalEvent
                            facilitiesName={passData?.facility?.full_name}
                        />)
                    // </Slider> 
                    : <h4 className='w-100 text-primary py-3 text-center'>No events available.</h4>}
            </Row>
        </div> : <div>
            <div className="row" id="event Details section">
                <div className="col">
                    <h3 className="fw-bold text-primary">Multiple Events - <small className="text-secondary fw-normal">{passData?.event_category?.name}</small></h3>
                </div>
            </div>
            <div className='multi_events'>
                <Slider {...settings}>
                    {passData?.all_event?.map((item, index) =>
                        <EventCard
                            key={index}
                            qrCodeValue={paymentResponse?.mapco_qrcode?.[index]?.qrcode}
                            imageUrl={(item?.image_url) ? item?.image_url : 'NoImage'}
                            title={item?.title}
                            detials={item?.description}
                            startDate={item?.start_time}
                            time={convertParkingTime(item?.parking_start_time, item?.parking_end_time)}
                            // paybaleAmount={item?.paybaleAmount}
                            id={item?.id}
                            parkingPrice={selectEventType == 'event' ? item?.event_rate : item?.price}
                            displayQr={displayQr}
                            hidePaymentDetails={hidePaymentDetails}
                            paymentResponse={paymentResponse}
                            isCrousalEvent
                            facilitiesName={passData?.facility?.full_name}
                        />)}
                </Slider>
            </div>
            <div className="bill-card mt-3">
                <div className="row mb-1 align-items-center">
                    <div className="col text-start">Parking Price{/* Including Tax*/}</div>
                    <div className="col text-end">${passData?.price}</div>
                </div>
                {getPriceBreakdown(sessionDetails)}
            </div>
            <div className="d-flex mb-4 p-3 bg-primary bg-opacity-10 border justify-content-between">
                <h3 className="fw-bold text-primary">Total Price -</h3>
                <h3 className="fw-bold text-secondary">${(sessionDetails?.data?.amount)?.toFixed(2)}</h3>
            </div>
        </div>
    )
}


MultipleEventCrousel.propTypes = {
    dispatch: PropTypes.func,
    notify: PropTypes.func,
    passData: PropTypes.object,
    isMainScreen: PropTypes.bool,
    selectEventType: PropTypes.string,
    sessionDetails: PropTypes.object,
    displayQr: PropTypes.bool,
    hidePaymentDetails: PropTypes.bool,
    paymentResponse: PropTypes.object,
    eventViewStyle: PropTypes.string
}

MultipleEventCrousel.defaulProps = {
    dispatch: noop,
    notify: noop,
    passData: EMPTY_OBJECT,
    isMainScreen: false,
    selectEventType: '',
    sessionDetails: EMPTY_OBJECT,
    displayQr: false,
    hidePaymentDetails: false,
    paymentResponse: EMPTY_OBJECT,
    eventViewStyle: ''
}

function mapStateToProps({ globalReducers }) {
    return {
        passData: globalReducers?.passData,
        selectEventType: globalReducers?.selectEventType,
        sessionDetails: globalReducers?.sessionDetails
    }
}
export default connect(mapStateToProps)(MultipleEventCrousel)